export default function* success(res) {
  //console.log(res);
}
